import { createModule } from '~/factories/store'
import mutations from '~/store/modules/shared/login-modal/mutations'
import state from '~/store/modules/shared/login-modal/state'

export default createModule({
  mutations,
  state
})
